module.exports = __webpack_public_path__ + "static/media/lefths.5b77e623.png";